
class IntegratorMappingListCell extends UITableViewCell
{
    private nameLabel: MUILabel = null;

    awakeFromHTML() {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
    }

    private _item: IntegratorMappingInfo = null;
    set item(item: IntegratorMappingInfo) {
        this._item = item;
        this.nameLabel.text = item.name;
    }
}
